(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["banner-with-text"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var animation_block = document.querySelectorAll('.animation_block');
    animation_block.forEach((block) => {
      var a_links = block.querySelectorAll('a');
      console.log('a_links', a_links);
      if (a_links.length > 3) {
      } else {
        switch (a_links.length) {
          case 1:
            break;
          case 2:
            var d_0 = a_links[0].querySelector('.desktop');
            a_links[0].style.animation = '4s linear 0s infinite normal none running ani_2_0';
            block.style.height = d_0.clientWidth + 'px';

            var d_1 = a_links[1].querySelector('.desktop');
            a_links[1].style.animation = '4s linear 0s infinite normal none running ani_2_1';
            break;
          case 3:
            var d_0 = a_links[0].querySelector('.desktop');
            a_links[0].style.animation = '6s linear 0s infinite normal none running ani_3_0';
            block.style.height = d_0.clientWidth + 'px';

            var d_1 = a_links[1].querySelector('.desktop');
            a_links[1].style.animation = '6s linear 0s infinite normal none running ani_3_1';

            var d_2 = a_links[2].querySelector('.desktop');
            a_links[2].style.animation = '6s linear 0s infinite normal none running ani_3_2';
            break;
        }
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-tab"] && !Shopify.designMode) return;
  try {
    
  // document.addEventListener('DOMContentLoaded', function () {
  //   var prodquery = document.querySelectorAll('.bls__product-name .customerizeTitle');
  //   prodquery.forEach((prodEl) => {
  //     var title = prodEl.attributes['data-title'].value;
  //     var newT = showCustomerizeName(title);
  //     prodEl.innerText = '';
  //     prodEl.insertAdjacentHTML('afterbegin', newT);
  //   });
  //   var sizequery = document.querySelectorAll('.bls__product-name .customerizeSize');
  //   sizequery.forEach((prodEl) => {
  //     var title = prodEl.attributes['data-title'].value;
  //     fetch('/products/' + title + '.js')
  //       .then((response) => response.json())
  //       .then((product) => {
  //         var cap = '',
  //           weight = '';
  //         var desc = product.description;
  //         var index = productList.findIndex((prod) => product.title.startsWith(prod.title));
  //         var sizeFlag = product.title.split(productList[index].title);
  //         var size = '';
  //         if (sizeFlag.length > 1) size = sizeFlag[1];
  //         if (size[0] == ' ') size = size.replace(' ', '');
  //         var CAPACITY_last = desc.split('CAPACITY')[1];
  //         var CAPACITY_WEIGHT = CAPACITY_last.split('WEIGHT')[0];
  //         var WEIGHT_last = desc.split('WEIGHT')[1].split('<h3>')[0];
  //         // 若链接标题包含尺寸，则根据尺寸定点数据
  //         if (size != '') {
  //           // 判断CAPACITY描述中是否包含尺寸信息
  //           if (CAPACITY_WEIGHT.split(size).length > 1) {
  //             cap = CAPACITY_WEIGHT.split(size)[1].split('</div>')[0];
  //           } else {
  //             cap = CAPACITY_WEIGHT.split('">')[1].split('</div>')[0];
  //           }
  //           // 判断WEIGHT描述中是否包含尺寸信息
  //           if (WEIGHT_last.split(size).length > 1) {
  //             weight = WEIGHT_last.split(size)[1].split('</div>')[0];
  //           } else {
  //             weight = WEIGHT_last.split('">')[1].split('</div>')[0];
  //           }
  //         } else {
  //           // 判断CAPACITY描述中是否包含多尺寸信息
  //           if (CAPACITY_WEIGHT.split('<div>').length == 1) {
  //             cap = CAPACITY_WEIGHT.split('">')[1].split('</div>')[0];
  //           }
  //           // 判断WEIGHT描述中是否包含多尺寸信息
  //           if (WEIGHT_last.split('<div>').length == 1) {
  //             weight = WEIGHT_last.split('">')[1].split('</div>')[0];
  //           }
  //         }
  //         if (cap != '' && weight != '') {
  //           prodEl.insertAdjacentHTML(
  //             'afterbegin',
  //             '<span style="font-size: 16px;color: rgba(166, 166, 166, 1);">' +
  //               cap.replace(':', '').replace('：', '').replace(size, '') +
  //               '&nbsp;' +
  //               weight.replace(':', '').replace('：', '').replace(size, '') +
  //               '</span>'
  //           );
  //         }
  //       });
  //   });
  // });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-produce"] && !Shopify.designMode) return;
  try {
    
  let pagination = {
    page: 0,
    pageSize: 2,
  };
  let total = -1;
  document.addEventListener('DOMContentLoaded', function () {
    getProdList();
  });

  window.addEventListener('scroll', function () {
    const scrollTop = window.scrollY;
    const windowHeight = window.innerHeight;
    const scrollHeight = document.documentElement.scrollHeight;

    if (scrollTop + windowHeight >= scrollHeight - 200) {
      getProdList();
    }
  });

  function getProdList() {
    if (total < 0 || pagination.page * pagination.pageSize < total) pagination.page += 1;
    else return;
    sendRequest('cares/product/list', 'get', pagination).then((res) => {
      console.log(res);
      total = res.count;
      if (total <= 0) {
        document.querySelector('.custom-image-group').style.display = 'flex';
      } else {
        document.querySelector('.custom-image-group').style.display = 'none';
      }
      if (res.results) {
        let prod_list = document.getElementById('pro_list');
        for (let i = 0; i < res.results.length; i++) {
          let prod = res.results[i];
          let title = replaceCustomerizeName(prod.product.alias);
          let prod_html = `<div class="mt42 prod flex">
              <div class="white w100 flex">
                <div class="img flex content-center">
                  <img
                    width="100%"
                    height="100%"
                    src="${prod.product.prod_image}"
                  >
                </div>
                <div class="info">
                  <div class="customerizeTitle">${title}</div>
                  <div class="prop">${prod.product.size} / ${prod.product.color}</div>
                  <div class="label mt42">Product security code</div>
                  <div class="content">${prod.ac_code}</div>
                  <div class="flex row mt42">
                    <div class="flex-1">
                      <div class="label">Renewal validity period</div>
                      <div class="content">${prod.renew_expired.replaceAll('-', ' / ')}</div>
                    </div>
                    <div class="flex-1">
                      <div class="label">Warranty validity period</div>
                      <div class="content">${prod.repair_expired.replaceAll('-', ' / ')}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>`;
          prod_list.innerHTML += prod_html;
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["horizontal-menu"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var prodquery = document.querySelectorAll('.horizontal .bls__menu_banner-heading.customerizeTitle');
    prodquery.forEach((prodEl) => {
      var title = prodEl.innerHTML;
      var newT = replaceCustomerizeName(title);
      prodEl.innerHTML = '';
      prodEl.insertAdjacentHTML('afterbegin', newT);
      if (prodEl.getElementsByTagName('div').length > 0) {
        var condNode = prodEl.getElementsByTagName('div')[0];
        condNode.style.width = condNode.clientWidth * 0.8 + 'px';
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-account"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded',function(){
    const e = document.getElementById('account-logout')
    null !== e && e.addEventListener('click', (e) => {
      sessionStorage.removeItem('ITOAccessToken')
    })
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  window.addEventListener('DOMContentLoaded', () => {
    setMaskHeight();
    // listenPersonalClick();
    listenAcceptClick();
    listenCloseClick();
    // getWorkshop()
  });
  window.addEventListener('resize', () => {
    setMaskHeight();
  });
  var product = {};

  // 设置定制遮罩层高度
  function setMaskHeight() {
    var maskquery = document.querySelector('.customerizePersonal.mask');
    if (maskquery) maskquery.style.minHeight = window.innerHeight + 'px';
  }
  // 监听产品详情定制按钮点击
  function listenPersonalClick() {
    var e = document.querySelector('.shopify-payment-button');
    e.addEventListener('click', () => {
      var maskquery = document.querySelector('.customerizePersonal.mask');
      if (maskquery.style.display == 'none') {
        maskquery.style.display = 'block';
      }
      setMaskHeight();
      getWorkshop();
    });
  }
  // 监听定制遮罩层关闭按钮
  function listenCloseClick() {
    var e = document.querySelector('.customerizePersonal.mask .close');
    e.addEventListener('click', () => {
      var maskquery = document.querySelector('.customerizePersonal.mask');
      if (maskquery.style.display == 'block') {
        maskquery.style.display = 'none';
      }
    });
  }
  // 监听定制遮罩层确认按钮
  function listenAcceptClick() {
    var e = document.querySelector('.customerizePersonal.mask .accept');
    e.addEventListener('click', () => {
      // 隐藏定制导航
      e = document.querySelector('.customerizePersonal.mask .view');
      e.style.display = 'none';
      e = document.querySelector('.customerizePersonal.mask .tour');
      e.style.display = 'none';
      // 显示定制主体
      e = document.querySelector('.customerizePersonal.mask .preview');
      e.style.display = 'unset';
      e = document.querySelector('.customerizePersonal.mask .form');
      e.style.display = 'unset';
    });
  }
  // 获取定制信息
  function getWorkshop() {
    // 获取69码
    // fetch(window.location.pathname+'.js')
    //   .then(response => response.json())
    //   .then(p =>{
    //     console.log(p)
    //   })

    // 查询定制信息
    // fetch('https://travel.itocases.com/v3/product/ito/workshop/skupart?sku='+'DACB22301O03GRN14B000').then(response => response.json())
    //   .then(p =>{
    //     console.log(p)
    //   })
    var r = new XMLHttpRequest();
    r.open('GET', 'https://travel.itocases.com/v3/product/ito/workshop/skupart?sku=' + 'DACB22301O03GRN14B000', true);
    r.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
    r.onreadystatechange = function () {
      var response = decodeURIComponent(r.responseText);
      if (response.code == 0) {
        product = response.data;
      }
      console.log(response.data);
    };
    r.send();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-register"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var footer = document.querySelector('footer');
    if (footer) {
      footer.style.display = 'none';
    }

    function resizeHandler() {
      var main = document.getElementById('MainContent');
      const isMobile = window.innerWidth <= 1024;
      if (isMobile) {
        main.style.background = 'none';
      } else {
        main.style.background =
          'url(https://cdn.shopify.com/s/files/1/0652/0605/9205/files/login_background.jpg?v=1724397636)';
        main.style.backgroundSize = 'cover';
      }
    }

    resizeHandler();

    window.addEventListener('resize', resizeHandler);
    const form = document.getElementById('create_customer');
    form.addEventListener('submit', function (event) {
      event.preventDefault(); // 阻止默认表单提交

      const formData = new FormData(form);
      fetch('/account', {
        method: 'POST',
        body: formData,
        credentials: 'same-origin',
      })
        .then((res) => res.text())
        .then((html) => {
          // 判断是否成功登录（通过返回 HTML 判断）
          if (html.includes('/account/logout') || html.includes('customer__account')) {
            let customer = '';
            // html = html.slice(html.indexOf('data-customer-id="'));
            // customer = html.slice(0, html.indexOf('"'));
            const searchStr = 'data-customer-id="';
            const startPos = html.indexOf(searchStr);

            if (startPos != -1) {
                // 1. 先跳过标记字符串本身，截取剩下的部分
                let tempHtml = html.slice(startPos + searchStr.length); 
                // 此时 tempHtml 是：12345" data-name="Jack">...
                
                // 2. 截取到下一个双引号出现为止
                customer = tempHtml.slice(0, tempHtml.indexOf('"'));
                // 结果：12345
            }
            // 事件处理逻辑
            let first_name = document.getElementById('first-name').value;
            let last_name = document.getElementById('last-name').value;
            let email = document.getElementById('email').value;
            let password = document.getElementById('password').value;
            registerRequest(first_name, last_name, email, password, customer, '', 'register')
              .then(function (res) {
                window.location.reload();
              })
              .catch(function (err) {
                alert(err);
              });
          } else {
            form.submit();
          }
        })
        .catch((err) => {
          console.error('登录出错：', err);
          alert('Something is error');
        });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-the-look"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded',function(){
    var prodquery = document.querySelectorAll('.bls__shop-lookbook-content .bls__section-subheading.customerizeTitle')
    prodquery.forEach(prodEl=>{
      var title = prodEl.innerText
      if(title){
        var newT = showCustomerizeName(title)
        prodEl.innerText = ''
        prodEl.insertAdjacentHTML('afterbegin',newT)
        // if(prodEl.getElementsByTagName('div').length>0){
        //   var condNode = prodEl.getElementsByTagName('div')[0]
        //   condNode.style.width = condNode.clientWidth*0.8 + 'px'
        // }
        if(prodEl.getElementsByTagName('text').length>0){
          var condNode = prodEl.getElementsByTagName('text')[1]
          condNode.style.color = 'black'
        }
      }
    })
  })
  
  document.addEventListener('DOMContentLoaded',function(){
    var prodquery = document.querySelectorAll('.bls__shop-lookbook-content .bls__section-des.customerizeTitle')
    prodquery.forEach(prodEl=>{
      var title = prodEl.innerText
      if(title){
        var newT = replaceCustomerizeName(title)
        prodEl.innerText = ''
        prodEl.insertAdjacentHTML('afterbegin',newT)
        // if(prodEl.getElementsByTagName('div').length>0){
        //   var condNode = prodEl.getElementsByTagName('div')[0]
        //   condNode.style.width = condNode.clientWidth*0.8 + 'px'
        // }
      }
    })
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded',function(){
    var prodquery = document.querySelectorAll('.slide__block-title.customerizeTitle')
    prodquery.forEach(prodEl=>{
      var title = prodEl.innerText
      console.log('slide',title)
      if(title){
        var newT = showCustomerizeName(title)
        prodEl.innerText = ''
        prodEl.insertAdjacentHTML('afterbegin',newT)
        // var condNode = prodEl.getElementsByTagName('div')[0]
        // condNode.style.width = condNode.clientWidth*0.8 + 'px'
      }
    })
  })
  

  } catch(e) { console.error(e); }
})();
})();
